export default __webpack_public_path__ + "static/media/podcast2.eb689b4c.png";